module.exports = __webpack_public_path__ + "img/create-spyder-icon.2d6506e1.svg";